import React from 'react';
import { useRouter } from 'next/router';
import * as S from './HeaderRightAction.styles';
import { DesktopHeaderRightAction } from './DesktopHeaderRightAction';
import { useCustomPush } from '@/components/CustomLink/CustomLink.hooks';
import { useBridgeAPI, useBridgeState } from '@/bridge/hooks';
import { usePageType } from '@/hooks/usePageType/usePageType';
import { PageType } from '@/hooks/usePageType/usePageType.types';
import { CloseWebviewIcon, PlusIcon } from '@/components/UI/Icons/Icons';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { getNewAdPageHref } from '@/utils/helpers';

interface HeaderRightActionProps {
  isMain?: boolean;
  hasAddNew?: boolean;
  rightAction?: React.ReactNode;
}

export const HeaderRightAction = ({
  isMain,
  hasAddNew,
  rightAction,
}: HeaderRightActionProps) => {
  const customPush = useCustomPush();
  const { asPath } = useRouter();
  const { isDesktop } = useBreakpoint();
  const { isWebView } = useBridgeState();
  const { closeWebview } = useBridgeAPI();
  const pageType = usePageType();

  function handleClick() {
    customPush(getNewAdPageHref(asPath));
  }

  switch (true) {
    case isDesktop:
      return <DesktopHeaderRightAction />;
    case isWebView && (isMain || pageType === PageType.Search):
      return (
        <S.CloseWebviewBtn
          data-testid="close-webview-btn"
          onClick={closeWebview}
        >
          <CloseWebviewIcon />
        </S.CloseWebviewBtn>
      );
    case isMain || hasAddNew:
      return (
        <S.NewAdBtn
          id="new_ad_link"
          data-testid={CommonTestIds.header.newAdButton}
          onClick={handleClick}
        >
          <PlusIcon className="icon-plus" />
        </S.NewAdBtn>
      );
    default:
      return rightAction;
  }
};
